export class CashFlowItemEntity {
  date!: string
  monthly!: number
  yearly!: number
  fees!: number
  t_shirts!: number
  refunds!: number
  total!: number
}
